<template>
  <custom-button v-if="$wizardConfig.customButton"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
    </slot>
  </custom-button>

  <!-- Fallback to Vuetify's button if no custom button is passed to the plugin -->
  <v-btn v-else
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
    </slot>
  </v-btn>
</template>

<script>
export default {
  created() {
    if (this.$wizardConfig.customButton) {
      this.$options.components['customButton'] = this.$wizardConfig.customButton
    }
  }
}
</script>